import React from 'react';
import { FeeOptionList, AddonOptionList, FieldList, PaymentInfo } from './form';

class RegForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fee: undefined,
      addons: [],
      subtotal: 0,
      tax: 0,
      total: 0,
      submitting: false,
      payment_errors: undefined,
      stripe_token: undefined,
      admin_bypass_payment: false,
      payment_method: undefined,
      payment_required: true
    };

    ['handleStateChange'].forEach((i) => {
      this[i] = this[i].bind(this);
    });
  }

  handleStateChange(change_type, change) {
    let state = this.state;
    switch(change_type) {
      case 'CHANGE_FEE':
        state.fee = change;
        break;
      case 'ADD_ADDON':
        state.addons.push(change);
        break;
      case 'REMOVE_ADDON':
        let i = state.addons.findIndex((a) => {return a.id == change.id});
        state.addons.splice(i, 1);
        break;
      case 'CHANGE_PAYMENT_METHOD':
        state.payment_method = change;
        break;
    }

    // payment required?
    state.payment_required = (state.admin_bypass_payment || state.payment_method == 'Cheque') ? false: true;

    // recalculate fees
    state.subtotal = state.tax = state.total = 0;
    let fee_index = this.props.eb ? 'eb_' : '';
    if (state.fee) {
      state.subtotal += Number(state.fee[fee_index+'subtotal']);
      state.tax += Number(state.fee[fee_index+'tax']);
      state.total += Number(state.fee[fee_index+'total']);
    }

    state.addons.forEach((a) => {
      state.subtotal += Number(a[fee_index+'subtotal']);
      state.tax += Number(a[fee_index+'tax']);
      state.total += Number(a[fee_index+'total']);
    });

    this.setState(state);
  }

  componentDidMount() {
    var that = this;

    $('input[name=admin_bypass_payment]').change(function() {
      that.setState({ admin_bypass_payment: $(this).prop('checked')});
    });

    // making life simple by keeping validation out of React for now
    $('#event-form').validate({
      errorElement: 'span',
      errorClass: 'red',
      errorPlacement: (error, element) => {
        error.appendTo( element.closest('.control-group').find('.error-target') );
      },
      submitHandler: (form) => {
        let $form = $(form);
        let skip_payment = that.state.total <= 0 || that.state.payment_method == 'Cheque' || (that.props.admin && $('input[name=admin_bypass_payment]:checked').length);

        let pay_data = {
          name: $('#card-name').val(),
          number: $('#card-number').val(),
          exp_month: $('#card-exp-month').val(),
          exp_year: $('#card-exp-year').val()
        }
        if ($('#card-cvc').val() && $('#card-cvc').val() != '') {
          pay_data['cvc'] = $('#card-cvc').val();
        }

        if (that.state.submitting) { return false; }

        $form.find('.btn-submit').hide();
        $form.find('.loading-spinner').show();
        that.setState({ submitting: true });

        if (skip_payment) {
          return true;
        } else {
          Stripe.card.createToken(pay_data, function(status, response) {
            if (response.error) {
              that.setState({ submitting: false, payment_errors: response.error.message });
              $form.find('.btn-submit').show();
              $form.find('.loading-spinner').hide();
            } else {
              // set stripe token and submit
              that.setState({ stripe_token: response['id'] });
              $form[0].submit();
            }
          });
          return false;
        }
      }
    });
  }

  render() {
    let addons;
    if (this.props.addons && this.props.addons.length > 0) {
      addons = <div><h2>Add-ons:</h2><AddonOptionList addons={this.props.addons} handleChange={this.handleStateChange} eb={this.props.eb} /></div>;
    }
    return <div className="reg-form">
      <h2>Please select a fee:</h2>
      <FeeOptionList fees={this.props.fees} handleChange={this.handleStateChange} eb={this.props.eb} />

      {addons}

      <h2>Registration information:</h2>
      <FieldList fields={this.props.fields} />

      <h2>Payment information:</h2>
      <PaymentInfo subtotal={this.state.subtotal} tax={this.state.tax} total={this.state.total} stripe_token={this.state.stripe_token} payment_errors={this.state.payment_errors} payment_method={this.state.payment_method} payment_required={this.state.payment_required} handleChange={this.handleStateChange} />
    </div>;
  }
}

export { RegForm };


/** WEBPACK FOOTER **
 ** ./src/components/public.js
 **/